import styled from '@emotion/styled';
import { css } from '@emotion/react';

import breakpoints from 'app/styles/constants/breakpoints';
import { startDirection } from 'app/styles/selectors/markup';
import Heading from 'app/components/layout/Heading.styled';

const { widthSmall, widthMedium } = breakpoints;

const HeroBlock = styled.section`
  label: HeroBlock;

  display: flex;

  @media (${widthSmall}) {
    align-items: center;
    justify-content: center;
  }

  @media (${widthMedium}) {
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: row;
  }
`;

const Content = styled.div`
  label: Content;

  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  padding-top: 2.5rem;

  @media (${widthSmall}) {
    padding-top: 4.5rem;
  }

  @media (${widthMedium}) {
    flex: 1 1 auto;
    align-items: flex-start;
    max-width: 41.25rem;
    padding-top: 7.5rem;
    text-align: initial;
    width: 100%;
  }
`;

const Title = styled(Heading)`
  label: Title;

  ${({ isGreetingLongerThan20Chars }) =>
    isGreetingLongerThan20Chars &&
    css`
      font-size: 1.75rem;
    `}

  margin-bottom: 2rem;
  order: 1;

  @media (${widthSmall}) {
    margin-bottom: 2.25rem;
  }

  @media (${widthMedium}) {
    margin-bottom: 1rem;
  }
`;

const Subtitle = styled.h1`
  label: Subtitle;

  margin-bottom: 2rem;

  @media (${widthSmall}) {
    margin-bottom: 2.25rem;
  }

  @media (${widthMedium}) {
    margin-bottom: 2rem;
    width: auto;
  }
`;

const SubtitleAndPerksHolder = styled.div`
  label: SubtitleAndPerksHolder;

  order: 3;

  @media (${widthSmall}) {
    max-width: 35.125rem;
    width: 100%;
  }

  @media (${widthMedium}) {
    max-width: unset;
    margin-bottom: 3rem;
  }
`;

const ButtonHolder = styled.div`
  label: ButtonHolder;

  order: 2;
  width: 100%;
  margin-bottom: 2rem;

  @media (${widthSmall}) {
    width: auto;
    margin-bottom: 2.25rem;
  }

  @media (${widthMedium}) {
    margin-bottom: 0;
    order: 4;
  }
`;

const ImageHolder = styled.div`
  label: ImageHolder;

  display: none;

  @media (${widthMedium}) {
    display: block;
    flex: 1 1 auto;
    margin-${startDirection}: 4.5rem;
  }
`;

const Image = styled.img`
  label: Image;

  max-width: 100%;
`;

const PerksHolder = styled.div`
  label: PerksHolder;

  padding: 0 1.625rem;

  @media (${widthSmall}) {
    padding: unset;
  }
`;

const Styled = {
  HeroBlock,
  Content,
  Title,
  Subtitle,
  ButtonHolder,
  Image,
  ImageHolder,
  SubtitleAndPerksHolder,
  PerksHolder,
};

export default Styled;
